import styled from 'styled-components';
import colors from '../../../assets/styles/colors';

export const FinanceInformationTwoRowLabel = styled.h6 `
  margin-top: 30px;
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: ${colors.textPrimary}
`;

export const FinanceInformationTwoRowNoElements = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 32px 1fr;
  align-items: center;
  margin-top: 20px;
`;

export const FinanceInformationTwoRowText = styled.span`
  margin-left: 12px;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: ${colors.textPrimary}
`;

export const FinanceInformationTwoRowIcon = styled.div`
  background: ${colors.bgTertiary};
  box-shadow: 0px 5px 10px ${colors.bgTertiaryShadow};
  border-radius: 16px;
  width: 32px;
  height: 32px;
  display: none;
  align-items: center;
  justify-content: center;
  `;

export const FinanceInformationTwoHide = styled.div`
  display: none;
`;

export const CentralInformationRowLabel = styled.h6`
  margin-top: 30px;
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: ${colors.textPrimary}
`;